import { FC } from 'react';
import MuiCollapse from '@mui/material/Collapse';
import { ICollapseProps } from './types';

export const Collapse: FC<ICollapseProps> = props => <MuiCollapse {...props} />;
